module.exports = __webpack_public_path__ + "img/flow-record-json.4489007b.png";